import { get } from 'api/helpers';
import env from 'utilities/env';

export const getRequirementsTags = () => get(env('REQUIREMENTS_TAGS_AWS_BUCKET'));

export default getRequirementsTags;
